import { DataHorarioRange, DataHorariosCallMe } from '../../../types/call-me-types';

type DiaSemana = 'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday' | 'saturday' | 'sunday';

const DIAS: { key: DiaSemana; nombre: string }[] = [
	{ key: 'monday', nombre: 'lunes' },
	{ key: 'tuesday', nombre: 'martes' },
	{ key: 'wednesday', nombre: 'miércoles' },
	{ key: 'thursday', nombre: 'jueves' },
	{ key: 'friday', nombre: 'viernes' },
	{ key: 'saturday', nombre: 'sábado' },
	{ key: 'sunday', nombre: 'domingo' },
];

const formatHora = (hora: string): string => {
	const [horas, minutos] = hora.split(':');
	return `${Number(horas)}:${minutos} h`;
};

const formatTramos = (tramos: DataHorarioRange[]): string =>
	tramos.map(({ from, to }) => `de ${formatHora(from)} a ${formatHora(to)}`).join(' y ');

const formatDias = (dias: string[]): string =>
	dias.length === 1 ? `el ${dias[0]}` : `de ${dias[0]} a ${dias[dias.length - 1]}`;

export const getTextoHorariosCallMe = (horarios: DataHorariosCallMe | null): string => {
	if (!horarios) return '';

	const grupos: { dias: string[]; tramos: DataHorarioRange[] }[] = [];
	let firmaAnterior: string | null = null;

	for (const { key, nombre } of DIAS) {
		const tramos = horarios[key];
		const firma = tramos.length > 0 ? JSON.stringify(tramos) : null;

		if (firma === null) {
			firmaAnterior = null;
		} else if (firma === firmaAnterior) {
			grupos[grupos.length - 1].dias.push(nombre);
		} else {
			grupos.push({ dias: [nombre], tramos });
			firmaAnterior = firma;
		}
	}

	const textos = grupos.map(({ dias, tramos }) => `${formatDias(dias)} ${formatTramos(tramos)}`);
	if (textos.length === 0) return '';

	const texto = textos.length === 1 ? textos[0] : `${textos.slice(0, -1).join(', ')} y ${textos[textos.length - 1]}`;
	const excepto = horarios.exceptions?.closed?.length ? ' (excepto festivos nacionales)' : '';
	return `Puedes solicitar que te llamemos ${texto}${excepto}.`;
};
